module.exports = __webpack_public_path__ + "media/images/fax - photocopies-0e71d84022528c73f70ce4c8e465f5d2.svg";